"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeprecatedVars = void 0;
var upperFirstLetter_1 = require("./upperFirstLetter");
var deprecatedRegexList = new RegExp('salutejs_');
var getDeprecatedVars = function (name) {
    var fileName = name.replace(deprecatedRegexList, '');
    var _a = fileName.split('__'), themeName = _a[0], themeMode = _a[1];
    if (!themeName || !themeMode) {
        return ['', ''];
    }
    var deprecatedThemeName = "".concat(themeMode).concat((0, upperFirstLetter_1.upperFirstLetter)(themeName));
    var deprecated = "\n/** @deprecated \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432\u043C\u0435\u0441\u0442\u043E \u044D\u0442\u043E\u0433\u043E ".concat(name, " */\nexport const ").concat(deprecatedThemeName, " = ").concat(name, ";");
    return [deprecated, deprecatedThemeName];
};
exports.getDeprecatedVars = getDeprecatedVars;
//# sourceMappingURL=getDeprecatedVars.js.map